import { host } from '../API';

export const getRatingHistory = async function (app: string, token: string, from: string, to: string) {
    const endpoint = host + "api/ratings/history/" + app + "?dateFrom=" + from + "&dateTo=" + to;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

    if (!response.ok) {
        const message = 'Failed to retrieve rating history. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
}